import createElement from '../logical-components/createElement';
import internalEvents from '../logical-components/internalEvents';
// Global helpers
import svgs from '../visual-components/svgs';
import renderText from '../logical-components/renderText';
import handleError from '../core/utils/handleError';
import widgetStyleDetection from '../logical-components/widgetStyleDetection';
import './scss/overlay.scss';
var overlayTemplate = function () { return "\n    <div class='_mnslq-overlay-backdrop'></div>\n    <div class='_msnlq-overlay-wrapper'>\n        <div class='_msnlq-oc-inner'>\n            <div class='_msnlq-oc-contentWrapper'>\n                <div class='_msnlq-oc-centerContent'>\n                    <div class='_msnlq-act-close'> ".concat(svgs.close, " </div>\n                    <div class='_msnlq-ovlay-cnt'></div>\n                </div>\n            </div>\n        </div>\n    </div>\n"); };
var overlay = function (_a) {
    var _b;
    var config = _a.config, section = _a.section;
    var isOpen = false;
    var events = internalEvents(config);
    // Element wrapper
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-overlay-wrapper' },
    ]);
    // Custom view
    if ((_b = section === null || section === void 0 ? void 0 : section.views) === null || _b === void 0 ? void 0 : _b.section) {
        var ele = section.views.section({
            config: config,
            section: section,
            svgs: svgs,
            renderText: renderText,
            wrapper: wrapper,
        });
        if (typeof ele === 'string') {
            wrapper.innerHTML = ele;
        }
        else {
            wrapper.appendChild(ele);
        }
    }
    else {
        // Default view
        wrapper.innerHTML = overlayTemplate();
    }
    var renderToElement = wrapper.querySelector('._msnlq-ovlay-cnt');
    var overlayElement = wrapper.querySelector('._msnlq-overlay-wrapper');
    if (!renderToElement) {
        handleError({
            section: 'overlay',
            message: '_mensenlinq widget error: For overlay section to work, your template must have an element with the class - "_msnlq-ovlay-cnt"',
        });
    }
    // Render
    var render = function (element) {
        if (renderToElement) {
            if (typeof element === 'string') {
                renderToElement.innerHTML = element;
            }
            else if (!element) {
                renderToElement.innerHTML = '';
            }
            else {
                renderToElement.appendChild(element);
            }
        }
        var rememberMeSection = wrapper.querySelector('._mnslq-rememberMe-element');
        if (rememberMeSection) {
            widgetStyleDetection(rememberMeSection, config);
        }
    };
    // Toggle
    var toggleState = function () {
        var _a, _b, _c;
        isOpen = !isOpen;
        // Allow people to tap into the open and close event
        if ((_a = section === null || section === void 0 ? void 0 : section.hooks) === null || _a === void 0 ? void 0 : _a.onOverlayToggle) {
            section.hooks.onOverlayToggle({
                isOpen: isOpen,
                section: section,
                config: config,
            });
        }
        // Prevent default toggle
        if ((_b = section === null || section === void 0 ? void 0 : section.options) === null || _b === void 0 ? void 0 : _b.disableDefaultToggleBehaviour) {
            return;
        }
        if ((_c = window === null || window === void 0 ? void 0 : window._mensenlinqEvents) === null || _c === void 0 ? void 0 : _c.emit) {
            window._mensenlinqEvents.emit('statistics', {
                type: 'overlayToggled',
                payload: {
                    time: Date.now(),
                    location: window.location.href,
                    isOpen: isOpen,
                },
            });
        }
        // Default usecase
        wrapper.classList.remove('_msnlq-ov-open');
        document.body.classList.remove('_msnliq-scroll-lock');
        if (isOpen) {
            wrapper.classList.add('_msnlq-ov-open');
            document.body.classList.add('_msnliq-scroll-lock');
        }
    };
    // Open/Close Mechanism
    events.on('openOverlay', function (element) {
        toggleState();
        // show loader
        render(element);
    });
    events.on('closeOverlay', function () {
        toggleState();
        // show loader
        render();
    });
    // Event handlers
    var handleElementClick = function (event) {
        if (!renderToElement.contains(event.target)) {
            toggleState();
            render();
        }
    };
    overlayElement.removeEventListener('click', handleElementClick);
    overlayElement.addEventListener('click', handleElementClick);
    return wrapper;
};
export default overlay;
